import { trackHelper } from "avatr-utils";
// import avatrNative from "@avatr/jsbridge";
// import { GetUserInfoRes } from "./native";
// import { getUserBaseInfo } from "services/app";

trackHelper.init(
  process.env.REACT_APP_TRACK_DOMAIN_SENDATA, // 埋点服务地址
  {
    // pub_product_line: "C-Avatr-H5-Community-Integral", // 所属业务: C-Avatr-H5-团队-项目
  }
);

// avatrNative.asyncCallNative<GetUserInfoRes>("getUserInfo").then((data) => {
//   if (data?.userId) {
//     trackHelper.login(data.userId);
//   }
// });

// if (clientHelper.isAvatrApp()) {
//   avatrNative.asyncCallNative('getUserInfo').then((data: any) => {
//     if (data?.userId) {
//       trackHelper.login(data.userId)
//     }
//   })
// } else if (clientHelper.isWeApp() || process.env.NODE_ENV === "development") {
//   getUserBaseInfo()
//     .then((res: any) => {
//       if (res.code === 0 && res.result?.userId) {
//         trackHelper.login(res.result?.userId)
//       }
//     })
//     .catch((err) => console.error(err))
// }